// theme/assets/shop-by-vehicle.js
/**
 * TFS Shop-by-Vehicle — DOM controller.
 * Reuses window.TFSFitment (api/getVehicle/setVehicle/addToGarage) and the pure
 * window.TFSShopByVehicleCore helpers. No YMM engine is rebuilt here.
 */
(function () {
  'use strict';
  if (window.__TFS_SBV__) return;
  window.__TFS_SBV__ = true;

  var root = document.querySelector('[data-sbv]');
  if (!root) return;
  var Core = window.TFSShopByVehicleCore;
  if (!Core) { console.error('[TFS SBV] core helpers missing'); return; }

  var form = root.querySelector('[data-sbv-form]');
  var sel = {
    year: root.querySelector('[data-sbv-select="year"]'),
    make: root.querySelector('[data-sbv-select="make"]'),
    model: root.querySelector('[data-sbv-select="model"]'),
    submodel: root.querySelector('[data-sbv-select="submodel"]'),
    drive: root.querySelector('[data-sbv-select="drive"]')
  };
  var field = {
    submodel: root.querySelector('[data-sbv-field="submodel"]'),
    drive: root.querySelector('[data-sbv-field="drive"]')
  };
  var goBtn = root.querySelector('[data-sbv-go]');
  var resetBtn = root.querySelector('[data-sbv-reset]');
  var statusEl = root.querySelector('[data-sbv-status]');
  var toggleBtns = root.querySelectorAll('[data-sbv-catalog]');

  var catalog = 'wheels';
  var records = [];     // /submodels vehicles for current year/make/model
  var autoDrive = '';   // drivetrain auto-resolved when the Drive step is hidden (<=1 option)
  var F = null;         // TFSFitment

  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  function setOptions(selectEl, opts, placeholder) {
    selectEl.textContent = '';
    var ph = document.createElement('option');
    ph.value = ''; ph.textContent = placeholder || '';
    selectEl.appendChild(ph);
    opts.forEach(function (o) {
      var v = (typeof o === 'object') ? o.value : o;
      var l = (typeof o === 'object') ? o.label : o;
      var opt = document.createElement('option');
      opt.value = String(v); opt.textContent = String(l);
      selectEl.appendChild(opt);
    });
  }
  function enable(selectEl, on) { selectEl.disabled = !on; }
  function showField(name, on) {
    if (field[name]) field[name].hidden = !on;
    if (!on && sel[name]) sel[name].value = '';
  }
  function setStatus(msg, kind) {
    if (!statusEl) return;
    statusEl.hidden = !msg;
    statusEl.textContent = msg || '';
    statusEl.className = 'tfs-sbv__status' + (kind ? ' tfs-sbv__status--' + kind : '');
  }

  var ORDER = ['make', 'model', 'submodel', 'drive'];
  function resetFrom(level) {
    var idx = ORDER.indexOf(level);
    for (var i = idx; i < ORDER.length; i++) {
      var k = ORDER[i];
      if (sel[k]) sel[k].value = '';
      if (k === 'make' || k === 'model') { setOptions(sel[k], [], cap(k)); enable(sel[k], false); }
    }
    if (idx <= ORDER.indexOf('submodel')) { showField('submodel', false); enable(sel.submodel, false); records = []; }
    if (idx <= ORDER.indexOf('drive')) { showField('drive', false); enable(sel.drive, false); autoDrive = ''; }
    updateReady();
  }

  function updateReady() {
    var ok = !!(sel.year.value && sel.make.value && sel.model.value)
      && (field.submodel.hidden || !!sel.submodel.value)
      && (field.drive.hidden || !!sel.drive.value);
    goBtn.disabled = !ok;
    resetBtn.hidden = !sel.year.value;
  }

  function setCatalog(cat) {
    catalog = Core.normalizeCatalog(cat);
    toggleBtns.forEach(function (b) {
      var on = b.getAttribute('data-sbv-catalog') === catalog;
      b.classList.toggle('tfs-sbv__toggle-btn--active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    goBtn.textContent = catalog === 'tires' ? 'Shop Tires' : 'Shop Wheels';
  }

  // ---- cascade (reuses the fitment public endpoints) ----
  function loadYears() {
    F.api.get('/years').then(function (data) {
      var years = (data && (data.years || data.data || data)) || [];
      setOptions(sel.year, years.map(String), 'Year');
      enable(sel.year, true);
      maybePrefill();
    }).catch(function (e) {
      console.error('[TFS SBV] years', e);
      setStatus('Sorry — we could not load the vehicle list. Please refresh.', 'error');
    });
  }
  function onYear() {
    resetFrom('make');
    if (!sel.year.value) return;
    F.api.get('/makes', { year: sel.year.value }).then(function (data) {
      var makes = (data && (data.makes || data.data || data)) || [];
      setOptions(sel.make, makes.map(String), 'Make');
      enable(sel.make, true); updateReady();
    }).catch(function (e) { console.error('[TFS SBV] makes', e); });
  }
  function onMake() {
    resetFrom('model');
    if (!sel.make.value) return;
    F.api.get('/models', { year: sel.year.value, make: sel.make.value }).then(function (data) {
      var models = (data && (data.models || data.data || data)) || [];
      setOptions(sel.model, models.map(String), 'Model');
      enable(sel.model, true); updateReady();
    }).catch(function (e) { console.error('[TFS SBV] models', e); });
  }
  function onModel() {
    resetFrom('submodel');
    if (!sel.model.value) return;
    F.api.get('/submodels', { year: sel.year.value, make: sel.make.value, model: sel.model.value }).then(function (data) {
      records = (data && (data.vehicles || data.data)) || [];
      if (!records.length) { setStatus("We don't have fitment data for that vehicle yet.", 'error'); return; }
      var subOpts = Core.buildSubmodelOptions(records);
      if (subOpts.length <= 1) {
        showField('submodel', false);
        applySubmodel(subOpts.length ? subOpts[0].value : '');
      } else {
        setOptions(sel.submodel, subOpts, 'Submodel');
        enable(sel.submodel, true); showField('submodel', true);
        updateReady();
      }
    }).catch(function (e) { console.error('[TFS SBV] submodels', e); });
  }
  function onSubmodel() { applySubmodel(sel.submodel.value); }

  // Decide the Drive step from the chosen submodel (owner "hide-when-<=1" rule).
  function applySubmodel(submodel) {
    if (field.submodel.hidden) sel.submodel.value = submodel; // keep auto-resolved value
    var drives = Core.deriveDrives(records, submodel);
    if (drives.length <= 1) {
      // Owner rule: <=1 drivetrain -> don't prompt. Stash the resolved value in
      // `autoDrive`; a hidden <select> can't hold a value with no matching <option>.
      autoDrive = drives.length ? drives[0] : '';
      showField('drive', false);
    } else {
      autoDrive = '';
      setOptions(sel.drive, drives, 'Drive');
      enable(sel.drive, true); showField('drive', true);
    }
    updateReady();
  }
  function onDrive() { updateReady(); }

  // Effective drivetrain: the visible select's value, or the auto-resolved one.
  function selectedDrive() { return field.drive.hidden ? autoDrive : (sel.drive.value || ''); }

  function onSubmit(e) {
    e.preventDefault();
    var submodel = sel.submodel.value || '';
    var drive = selectedDrive();
    var vehicleId = Core.resolveVehicleId(records, submodel, drive);
    var vehicle = {
      year: sel.year.value, make: sel.make.value, model: sel.model.value,
      submodel: submodel, chassis: drive,
      id: vehicleId, vehicleId: vehicleId
    };
    try { F.setVehicle(vehicle, { skipURL: true }); F.addToGarage(vehicle); } catch (err) {}
    window.location.href = Core.buildResultUrl(catalog, vehicle);
  }

  // ---- prefill from an existing garage vehicle ----
  var _prefilled = false;
  function maybePrefill() {
    if (_prefilled) return;
    _prefilled = true;
    var v = (F.getVehicle && F.getVehicle()) || null;
    if (!v || !v.year) return;
    var yearOk = [].some.call(sel.year.options, function (o) { return o.value === String(v.year); });
    if (!yearOk) return;
    sel.year.value = String(v.year);
    F.api.get('/makes', { year: v.year }).then(function (d) {
      var makes = (d && (d.makes || d.data || d)) || [];
      setOptions(sel.make, makes.map(String), 'Make'); enable(sel.make, true);
      if (!v.make) { updateReady(); return null; }
      sel.make.value = String(v.make);
      return F.api.get('/models', { year: v.year, make: v.make });
    }).then(function (d) {
      if (!d) return null;
      var models = (d && (d.models || d.data || d)) || [];
      setOptions(sel.model, models.map(String), 'Model'); enable(sel.model, true);
      if (!v.model) { updateReady(); return null; }
      sel.model.value = String(v.model);
      return F.api.get('/submodels', { year: v.year, make: v.make, model: v.model });
    }).then(function (d) {
      if (!d) return;
      records = (d && (d.vehicles || d.data)) || [];
      var subOpts = Core.buildSubmodelOptions(records);
      if (subOpts.length > 1) {
        setOptions(sel.submodel, subOpts, 'Submodel');
        enable(sel.submodel, true); showField('submodel', true);
        sel.submodel.value = v.submodel || '';
      } else {
        showField('submodel', false);
      }
      applySubmodel(v.submodel || (subOpts[0] && subOpts[0].value) || '');
      if (v.chassis && !field.drive.hidden) sel.drive.value = v.chassis;
      updateReady();
      if (!goBtn.disabled) {
        setStatus('Showing your ' + (F.formatVehicle ? F.formatVehicle(v) : 'vehicle') + '. Pick Wheels or Tires, then Shop.', 'ok');
      }
    }).catch(function () { /* best-effort prefill */ });
  }

  // ---- events ----
  sel.year.addEventListener('change', onYear);
  sel.make.addEventListener('change', onMake);
  sel.model.addEventListener('change', onModel);
  sel.submodel.addEventListener('change', onSubmodel);
  sel.drive.addEventListener('change', onDrive);
  form.addEventListener('submit', onSubmit);
  resetBtn.addEventListener('click', function () {
    sel.year.value = ''; resetFrom('make'); enable(sel.year, true); setStatus('', null);
  });
  toggleBtns.forEach(function (b) {
    b.addEventListener('click', function () { setCatalog(b.getAttribute('data-sbv-catalog')); });
  });

  // ---- init ----
  var urlCat = new URLSearchParams(window.location.search).get('catalog');
  setCatalog(urlCat || root.getAttribute('data-default-catalog') || 'wheels');

  function start() { F = window.TFSFitment; loadYears(); }
  if (window.TFSFitment) start();
  else document.addEventListener('tfs-fitment-ready', start, { once: true });
})();
